import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import ImageCropper from '@/components/imageCropper/imageCropper';
import {
  priorityicon1,
  priorityicon2,
  priorityicon3,
  priorityimg1,
  priorityimg2,
  priorityimg3,
} from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { RootState } from '@/core/redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';

const PriorityEditModal = ({ themeData, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>();
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [icons, setIcons] = useState<Array<string>>([]);
  const [images, setImages] = useState<Array<string>>([]);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);
  const handleHeaderChange = (e: any, index?: any) => {
    const { value, name } = e.target;
    let updatedCards: any = [...editData.theme_1.home.section_4.cards];
    if (index != undefined) {
      updatedCards = [...editData.theme_1.home.section_4.cards];
      updatedCards[index] = {
        ...updatedCards[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_4: {
            ...prevJsonData.theme_1.home.section_4,
            [name]: value,
            cards: updatedCards,
          },
        },
      },
    }));
  };

  const addCollection = () => {
    let updatedCards: any = [...editData.theme_1.home.section_4.cards];

    let newCard = {
      heading: '',
      icon: priorityicon1,
      image: priorityimg1,
      paragraph: '',
    };
    updatedCards.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_4: {
            ...prevJsonData.theme_1.home.section_4,
            cards: updatedCards,
          },
        },
      },
    }));
  };
  const removeCard = (index: any) => {
    let updatedCards: any = [...editData.theme_1.home.section_4.cards];
    
    // Prevent deleting the last card
    if (updatedCards.length <= 1) {
      toast.error('At least one card is required');
      return;
    }
    
    updatedCards.splice(index, 1);
    
    // Adjust activeTab if necessary
    if (activeTab >= updatedCards.length) {
      setActiveTab(updatedCards.length - 1);
    }
    
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_4: {
            ...prevJsonData.theme_1.home.section_4,
            cards: updatedCards,
          },
        },
      },
    }));
  };

  const handleIconChange = (image: string, type: string) => {
    const updatedCards = [...editData.theme_1.home.section_4.cards];
    if (type === 'icon') {
      updatedCards[activeTab] = {
        ...updatedCards[activeTab],
        icon: image,
      };
    } else {
      updatedCards[activeTab] = {
        ...updatedCards[activeTab],
        image: image,
      };
    }

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_4: {
            ...prevJsonData.theme_1.home.section_4,
            cards: updatedCards,
          },
        },
      },
    }));
  };

  const updateImageSection = async (e: any, type: string) => {
    const image = e.target.files[0];
    // if (type === "icon") {
    //   setCropImageHeight("99");
    //   setCropImageWidth("98");
    // } else {
    //   setCropImageHeight("305");
    //   setCropImageWidth("205");
    // }

    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result, type);
      };
    }
  };

  const handleCroppedImage = async (image: any, type: string) => {
    setShowCropModal(false);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleIconChange(imageLink, type);
    }
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  useEffect(() => {
    setActiveTab(0);
  }, []);

  // Load icons from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template1';
      const currentTemplate = templateImages[templateKey];
      const iconImages = currentTemplate?.icon || [];
      
      if (Array.isArray(iconImages) && iconImages.length > 0) {
        const iconUrls = iconImages.map((img: any) => img.url);
        setIcons(iconUrls);
      } else {
        setIcons([]);
      }

      const cardImages = currentTemplate?.image || [];
      
      if (Array.isArray(cardImages) && cardImages.length > 0) {
        const imageUrls = cardImages.map((img: any) => img.url);
        setImages(imageUrls);
      } else {
        setImages([]);
      }
    } else {
      setIcons([]);
      setImages([]);
    }
  }, [templateImages, template]);

  // Auto-generate prompt based on card context for Icons
  const generateAutoPromptIcon = (): string => {
    const currentCard = editData?.theme_1?.home?.section_4?.cards?.[activeTab];
    const heading = currentCard?.heading || '';
    const paragraph = currentCard?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional icon for website card section';
    
    if (heading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add icon-specific styling
    contextPrompt += ', clean modern aesthetic, minimalist design, suitable for icon, vibrant colors, high quality, clean background, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Auto-generate prompt based on card context for Images
  const generateAutoPromptImage = (): string => {
    const currentCard = editData?.theme_1?.home?.section_4?.cards?.[activeTab];
    const heading = currentCard?.heading || '';
    const paragraph = currentCard?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional image for website card section';
    
    if (heading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add image-specific styling
    contextPrompt += ', clean modern aesthetic, professional design, suitable for card image, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    // Auto-apply the icon to the current active card
    handleIconChange(iconUrl, 'icon');
    
    // Add to icons array for slider
    setIcons(prevIcons => [...prevIcons, iconUrl]);
  };

  // Handle AI image save
  const handleAIImageSave = (imageUrl: string) => {
    // Auto-apply the image to the current active card
    handleIconChange(imageUrl, 'img');
    
    // Add to images array for slider
    setImages(prevImages => [...prevImages, imageUrl]);
  };
  // HTML
  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Four Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Section Title</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={editData?.theme_1?.home?.section_4?.title}
                        maxLength={250}
                        onChange={handleHeaderChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_1?.home?.section_4?.h2color}
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={editData?.theme_1?.home?.section_4?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 2 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_1?.home?.section_4?.h3color}
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={editData?.theme_1?.home?.section_4?.h3color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_1?.home?.section_4?.paracolor}
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={editData?.theme_1?.home?.section_4?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_1?.home?.section_4?.cards?.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option nav-option-wrapper">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card Section {index + 1}
                          </a>
                          <a
                            className="nav-option-close"
                            onClick={() => {
                              removeCard(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_1?.home?.section_4?.cards.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active text-center">
                            <img
                              src={card.icon}
                              alt={`Card Icon ${index + 1}`}
                              className="img-fluid"
                              style={{ height: 'auto', objectFit: 'contain', textAlign: 'center' }}
                            />
                          </div>
                          <div className="img-options w-100">
                            {icons.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {icons.map((icons: any, iconIndex: any) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div className="img-option" style={{ cursor: 'pointer', padding: '5px' }}>
                                      <img
                                        src={icons}
                                        onClick={() => {
                                          handleIconChange(icons, 'icon');
                                        }}
                                        alt="Icon"
                                        className="img-fluid rounded"
                                        style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '4px' }}
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Icons Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI icons or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* AI Icon Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />
                      <div className="mb-3">
                        <label className="form-label">Upload Icon</label>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e: any) => {
                            updateImageSection(e, 'icon');
                          }}
                          className="form-control"
                          name="image"
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active">
                            <img
                              src={card.image}
                              alt={`Card Image ${index + 1}`}
                              className="img-fluid"
                              style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                            />
                          </div>
                          <div className="img-options w-100">
                            {images.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {images.map((img: any, iconIndex: any) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div className="img-option" style={{ cursor: 'pointer', padding: '5px' }}>
                                      <img
                                        src={img}
                                        onClick={() => {
                                          handleIconChange(img, 'img');
                                        }}
                                        alt="Card Image"
                                        className="img-fluid rounded"
                                        style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '4px' }}
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div className="empty-slider-state text-center py-4">
                                <div className="empty-state-content">
                                  <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                  <h6 className="text-muted mb-2">No Images Available</h6>
                                  <p className="text-muted small mb-3">
                                    Generate AI images or upload your own to see them here
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {/* AI Image Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptImage}
                        onSave={handleAIImageSave}
                        imageType="image"
                        defaultWidth="1024"
                        defaultHeight="1024"
                        title="AI Image"
                        autoGenerate={true}
                        template={template}
                      />
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={(e: any) => {
                            updateImageSection(e, 'img');
                          }}
                          name="image"
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">
                            Heading<small>(max 250 char)</small>
                          </label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleHeaderChange({
                                target: {
                                  name: 'heading',
                                  value: content,
                                },
                              }, activeTab);
                            }}
                            contentType="hero_section"
                            placeholder="Describe what you want in your heading. Example: 'Write a catchy heading about fast delivery'"
                            context="This is for a priority card heading and 2 words are enough"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="heading"
                          value={card.heading}
                          onChange={(e: any) => {
                            handleHeaderChange(e, activeTab);
                          }}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">
                            Paragraph
                          </label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleHeaderChange({
                                target: {
                                  name: 'paragraph',
                                  value: content,
                                },
                              }, activeTab);
                            }}
                            contentType="website_description"
                            placeholder="Describe what you want in your paragraph. Example: 'Write about our service quality and customer benefits'"
                            context="This is for a priority card description and 2 lines are enough"
                          />
                        </div>
                        <textarea
                          className="form-control"
                          name="paragraph"
                          value={card.paragraph}
                          onChange={(e: any) => {
                            handleHeaderChange(e, activeTab);
                          }}
                          maxLength={1200}
                          rows={3}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div onClick={addCollection} className="col text-center">
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default PriorityEditModal;
